var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H2.55556L2.86667 2.55556M4.11111 8.77778H11.8889L15 2.55556H2.86667M4.11111 8.77778L2.86667 2.55556M4.11111 8.77778L2.32775 10.5611C1.83778 11.0511 2.1848 11.8889 2.87772 11.8889H11.8889M11.8889 11.8889C11.0298 11.8889 10.3333 12.5853 10.3333 13.4444C10.3333 14.3036 11.0298 15 11.8889 15C12.748 15 13.4444 14.3036 13.4444 13.4444C13.4444 12.5853 12.748 11.8889 11.8889 11.8889ZM5.66667 13.4444C5.66667 14.3036 4.97022 15 4.11111 15C3.252 15 2.55556 14.3036 2.55556 13.4444C2.55556 12.5853 3.252 11.8889 4.11111 11.8889C4.97022 11.8889 5.66667 12.5853 5.66667 13.4444Z",
    stroke: "#525252",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.818046935cf9ec801d3422161d014d93.svg";
export { ForwardRef as ReactComponent };